import { KeyboardEvent } from 'react';

export function handleSingleLineKeys({
  onSave,
  onCancel,
  saveOnEnter = true,
}: {
  onSave: () => void;
  onCancel: () => void;
  saveOnEnter?: boolean;
}) {
  return (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      onCancel();
      return;
    }

    if (event.key !== 'Enter') {
      return;
    }

    const isCommandEnter = event.metaKey || event.ctrlKey;

    if (saveOnEnter || isCommandEnter) {
      event.preventDefault();
      onSave();
    }
  };
}
